import { render } from "./browserPage.vue?vue&type=template&id=400c98f6"
import script from "./browserPage.vue?vue&type=script&lang=js"
export * from "./browserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__